import React from 'react';
import MailingListForm from '../mailing-list';
var NewsgroupForm = function NewsgroupForm() {
  return /*#__PURE__*/React.createElement(MailingListForm, {
    isNewsgroup: true
  });
};
export default NewsgroupForm;